module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.410504d4.otf";